/* SMÆCCAN LUXE — motion layer v2.
   IntersectionObserver + pointer events only (no scroll listeners),
   honors prefers-reduced-motion throughout. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var i;

  /* ---------- Directional CTA fill: record pointer entry point ---------- */
  if (!reduce) {
    document.addEventListener('pointerenter', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.button:not(.button--secondary)') : null;
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      btn.style.setProperty('--lux-mx', ((e.clientX - r.left) / r.width) * 100 + '%');
      btn.style.setProperty('--lux-my', ((e.clientY - r.top) / r.height) * 100 + '%');
    }, true);
  }

  /* ---------- Add-to-cart tactile feedback ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.style.transition = 'transform 0.18s cubic-bezier(0.16,1,0.3,1)';
        btn.style.transform = 'scale(0.97)';
        setTimeout(function () { btn.style.transform = ''; }, 220);
      }
    }
  });

  if (reduce) return; /* everything below is pure motion */

  /* ---------- Reveal on scroll ---------- */
  var selectors = [
    '.collection .card-wrapper',
    '.collapsible-content__heading',
    '.collapsible-content .accordion',
    '.featured-collection .title-wrapper-with-link',
    '.collage-wrapper .collage__item',
    '.rich-text__blocks',
    '.newsletter__wrapper',
    '.lux-craft__intro',
    '.lux-strip__cell',
    '.featured-product .product__media-wrapper',
    '.product__info-container > *'
  ];
  var nodes = document.querySelectorAll(selectors.join(','));
  for (i = 0; i < nodes.length; i++) nodes[i].classList.add('lux-reveal');

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }
  );
  var revealNodes = document.querySelectorAll('.lux-reveal');
  for (i = 0; i < revealNodes.length; i++) revealObserver.observe(revealNodes[i]);

  /* ---------- Craft pinned scrolltelling ---------- */
  var craft = document.querySelector('[data-lux-craft]');
  var isDesktop = window.matchMedia('(min-width: 750px)').matches;
  if (craft && isDesktop) {
    var panels = craft.querySelectorAll('[data-craft-panel]');
    var sentinels = craft.querySelectorAll('[data-craft-sentinel]');
    var progressFill = craft.querySelector('[data-craft-progress]');
    var visible = {};
    var setStep = function (idx) {
      for (var p = 0; p < panels.length; p++) {
        panels[p].classList.toggle('is-current', p === idx);
      }
      if (progressFill) {
        progressFill.style.width = (((idx + 1) / panels.length) * 100) + '%';
      }
    };
    var craftObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = parseInt(entry.target.getAttribute('data-craft-sentinel'), 10);
          visible[idx] = entry.isIntersecting;
        });
        var current = -1;
        for (var k = 0; k < sentinels.length; k++) {
          if (visible[k]) current = k;
        }
        if (current >= 0) setStep(current);
      },
      { threshold: 0.35 }
    );
    for (i = 0; i < sentinels.length; i++) craftObserver.observe(sentinels[i]);
    setStep(0);
  }

  /* ---------- Product card tilt (rAF-throttled pointer transform) ---------- */
  if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
    var ticking = false;
    var pending = null;
    var applyTilt = function () {
      ticking = false;
      if (!pending) return;
      var card = pending.card, e = pending.event;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--lux-ry', (px * 6) + 'deg');
      card.style.setProperty('--lux-rx', (py * -6) + 'deg');
    };
    document.addEventListener('pointermove', function (e) {
      var wrapper = e.target && e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (!wrapper) return;
      var card = wrapper.querySelector('.card');
      if (!card) return;
      pending = { card: card, event: e };
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(applyTilt);
      }
    });
    document.addEventListener('pointerout', function (e) {
      var wrapper = e.target && e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (!wrapper) return;
      var card = wrapper.querySelector('.card');
      if (!card) return;
      card.style.setProperty('--lux-ry', '0deg');
      card.style.setProperty('--lux-rx', '0deg');
    });
  }
})();
